import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export default class MsLessonPerformanceController extends Controller {
  queryParams = ['selectedLesson', 'sort', 'pageNumber', 'perPage']

  @tracked selectedLesson = 1

  @tracked sort = 'best_score'

  @tracked pageNumber = 1

  @tracked perPage = 25
}
